define.alias("ember-cli-clipboard/components/copy-button", "calendar/components/copy-button");